import React from 'react';
import ReactModal from 'react-modal';
import ReactTooltip from 'react-tooltip';
import './style.scss';
import { POINT_CONVERSION_COMPRESSED } from 'constants';

import ColombiaDirectDebitForm from './co-form';
import ArgentinaDirectDebitForm from './ar-form';

ReactModal.setAppElement('body');

export default class Form extends React.Component<any> {
    constructor(props) {
        super(props);
    }

    render() {
        const { country } = this.props;

        switch (country) {
            case "AR":
                return <ArgentinaDirectDebitForm
                {...this.props}
            />;
            case "CO":
                return <ColombiaDirectDebitForm
                {...this.props}
            />;
        }

    }
  }